import { useEffect, useRef, useState } from "react";
import { gsap } from "gsap";
import Emitter from "../../helpers/emitters";

export const useAnimationTutorial = () => {
	const container = useRef(null);
	const [animation, setAnimation] = useState(false);
	const [close, setClose] = useState(false);
	const [initanimation, setInitanimation] = useState(false);
	const ctx = useRef(null);
	const tl = useRef(null);

	const animationMethod = () => {
		tl.current
			.to(container.current, {
				duration: 1.2,
				opacity: 1,
				display: "grid",
			})
			.reverse();
	};

	useEffect(() => {
		ctx.current = gsap.context(() => {
			tl.current = gsap.timeline();
			animationMethod();
		});
		return () => ctx.current.revert();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	const closeTutorial = () => {
		tl.current.reverse();
		setClose(true);
		setInitanimation(false);
	};

	useEffect(() => {
		if (animation) {
			if (!close) {
				tl.current.play();
				setInitanimation(true);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [animation]);

	useEffect(() => {
		Emitter.on("activeTutorial", (data) => {
			setAnimation(true);
		});
	}, []);

	useEffect(() => {
		if (initanimation) {
			setTimeout(() => {
				closeTutorial();
			}, 5000);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [initanimation]);

	return { container, closeTutorial };
};
